export const I18N_NAMESPACES = [
  'common',
  'dashboard',
  'library',
  'onboarding',
  'notFound',
  'profile',
  'purchase',
  'session',
  'statistics',
  'setup',
  'voucher',
] as const

export type I18nNamespace = (typeof I18N_NAMESPACES)[number]

export const DEFAULT_I18N_NAMESPACE: I18nNamespace = 'common'
